import { combineReducers } from 'redux';
import clientReducer from '../client/client-reducer';
import scopeReducer from '../scopes/scope-reducer';

const rootReducer = combineReducers({
	clientReducer,
	scopeReducer
});

export default rootReducer;
